'use client'

/**
 * Upload a captured screenshot into the private feedback-screenshots bucket
 * (owner-scoped RLS) and return its object path for the ticket row.
 * Best-effort: returns null on any failure so the ticket still goes through
 * without the attachment.
 */

import { createClient } from '@/shared/lib/supabase/client'
import { screenshotStoragePath } from './errorReport'

export const SCREENSHOT_BUCKET = 'feedback-screenshots'

export async function uploadScreenshot(blob: Blob): Promise<string | null> {
  try {
    const supabase = createClient()
    const {
      data: { user },
    } = await supabase.auth.getUser()
    if (!user) return null

    const path = screenshotStoragePath(user.id, crypto.randomUUID())
    const { error } = await supabase.storage
      .from(SCREENSHOT_BUCKET)
      .upload(path, blob, { contentType: 'image/jpeg' })
    if (error) {
      console.warn('[errorReport] screenshot upload failed:', error.message)
      return null
    }
    return path
  } catch (err) {
    console.warn('[errorReport] screenshot upload failed:', err)
    return null
  }
}
